import React, { useEffect } from "react"

import { useNavigate } from "react-router-dom"

import { PrimaryText } from "@front-shared/elements/primaryText.element"
import { SpinnerElement } from "@front-shared/elements/spinner.element"

import { ROUTES_CONFIG } from "../../../config/routes.config"
import { AuthService } from "../../../services/auth.service"

export const AuthCallbackComponent: React.FunctionComponent = () => {
    const navigate = useNavigate()

    useEffect(() => {
        const handleCallback = async () => {
            try {
                // The federated sign-in callback is automatically handled by AWS Amplify
                // We just need to wait for the authentication to complete and then redirect

                // Check if user is authenticated
                const isAuthenticated = await AuthService.isLoggedIn()

                if (isAuthenticated) {
                    // Redirect to the main application
                    navigate(ROUTES_CONFIG.baseApplicationUrl, {
                        replace: true,
                    })
                } else {
                    // If authentication failed, redirect back to login
                    navigate(ROUTES_CONFIG.loginUrl, { replace: true })
                }
            } catch (error) {
                console.error("Auth callback error:", error)

                // Redirect to login on error
                navigate(ROUTES_CONFIG.loginUrl, { replace: true })
            }
        }

        handleCallback()
    }, [navigate])

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <SpinnerElement containerClassName="mb-[16px]" />

            <PrimaryText typography="subtitle" centered>
                Completing sign-in...
            </PrimaryText>
        </div>
    )
}
